module.exports = __webpack_public_path__ + "Trip-Cancellation-New-gray-h.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/Trip-Cancellation-New-gray-h.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/Trip-Cancellation-New-gray-h.png
// module chunks = 10